import React from 'react';
import NukaCarousel from 'nuka-carousel';
import { NextButton, PrevButton } from './NavigationButton';
import PaginationDots from './PaginationDots';

const Carousel = ({ children, ...props }) => (
  <NukaCarousel
    renderCenterRightControls={ NextButton }
    renderCenterLeftControls={ PrevButton }
    renderBottomCenterControls={ PaginationDots }
    { ...props }
  >
    {children}
  </NukaCarousel>
);

Carousel.NextButton = NextButton;
Carousel.PrevButton = PrevButton;
Carousel.PaginationDots = PaginationDots;

export default Carousel;
